import { render, staticRenderFns } from "./ApplicationForm.vue?vue&type=template&id=5052afbd&scoped=true"
import script from "./ApplicationForm.vue?vue&type=script&lang=ts"
export * from "./ApplicationForm.vue?vue&type=script&lang=ts"
import style0 from "./ApplicationForm.vue?vue&type=style&index=0&id=5052afbd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5052afbd",
  null
  
)

export default component.exports